import { CRUDEntity } from "../abstracts/CRUDEntity";
import { FormActions } from "../abstracts/mixins/FormActions";

import { updateTables } from "../../jobs-flow/updateTables";
import { RelatedEntities } from "../abstracts/mixins/RelatedEntities";
import { HasWorkers } from "../abstracts/mixins/HasWorkers";
import { HasStatus } from "../abstracts/mixins/HasStatus";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { HasComments } from "../abstracts/mixins/HasComments";
import { HasAttachments } from "../abstracts/mixins/HasAttachments";

export class Job extends CRUDEntity {

    static #statuses = {
        APPROVED: 1,
        IN_PROGRESS: 2,
        COMPLETED: 3,
        CANCELED: 4,
        CLOSED: 5,
    }

    constructor(id=null) {
        super();
        this.entityClass = 'job';
        // /worker-cabinet/v2/... is served by WorkerAttachmentController. It used to be
        // /worker-cabinet/... — the V1 page's controller — which made the V2 cabinet's checklist
        // photo depend on the page we are deleting.
        // TRAP: the test reads the LAST path segment, so any future /worker-cabinet/<something>
        // page silently falls back to the office root.
        this.urlRoot = /worker-cabinet/.test(location.href.split(/[\\\/]+/).pop())?'/worker-cabinet/v2/job':'/jobs-flow/job';
        this.sectionRootUrl = /worker-cabinet/.test(location.href.split(/[\\\/]+/).pop())?'/worker-cabinet':'/jobs-flow';
        this.id = id;

        Object.assign(Job.prototype, FormActions);
        Object.assign(Job.prototype, EntityModalForm);
        Object.assign(Job.prototype, HasStatus);
        Object.assign(Job.prototype, HasWorkers);
        Object.assign(Job.prototype, RelatedEntities);
        Object.assign(Job.prototype, HasComments);
        Object.assign(Job.prototype, HasAttachments);
        this.setAttachmentCallbackPreview();

        Job.prototype.collectDataInForm = function(formId) {
            let data = FormActions.collectDataInForm(formId);
            if ($('#edit-job').find('.workers-select').length>0) {
                data.workers = this.collectWorkersInForm();
                console.log('Job.collectDataInForm:', data);
            }
            return data;
        }
    }

    returnToRequest() {
        $.ajax({
            url: `${this.urlRoot}/${this.id}/return-to-request`,
            method: 'POST',
            success: updateTables
        });
    }
}
